import React from 'react';

import {labels} from '../../../../../util/utils';
import {contactListColumnIds} from '../../../../../util/uiconstants';

import OutputText from '@ey/canvascoreservices/OutputText';

const BasicNameColumn = ({item}) => {
	let text = labels.columnName;
	if (item !== null) text = `${item.name} ${item.lastName}`;

	return (
		<OutputText body2 light ellipsis title={text}>
			{text}
		</OutputText>
	);
};

export const config = (labels) => ({
	id: contactListColumnIds.basicName,
	label: labels.columnName,
	propName: 'name',
	width: 'minmax(var(--px-200), 1fr)',
	sortBy: ['name', 'lastName'],
	customCell: (item) => {
		const props = {item};
		return <BasicNameColumn {...props} />;
	}
});
